import { findRule } from '../Utils'

const validate = vObj => {
  let errorBag = vObj.errorBag
  let params = findRule(errorBag, 'required_if').ruleParams.split(',')
  let requiredValue = params[1]
  let value = vObj.value
  let requiredField = params[0]
  let requiredFieldVal = vObj.vnode.context[requiredField]
  let required = requiredValue.includes(String(requiredFieldVal).trim())
  let otherFieldLabel = vObj.vnode.context.$validator.find(
    v => v.vmod === requiredField
  ).fieldlabel
  let rule = findRule(errorBag, 'required_if')

  rule.feedback = `${
    vObj.fieldlabel
  } is required if you have answered ${otherFieldLabel} with a ${
    requiredValue ? 'Yes' : 'No'
  }`

  if (!required) {
    return true
  }
  return !!String(value).trim().length
}

export { validate }

export default {
  validate
}
